import { render, staticRenderFns } from "./ForgetShop.vue?vue&type=template&id=35a1a50c&scoped=true&"
import script from "./ForgetShop.vue?vue&type=script&lang=js&"
export * from "./ForgetShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a1a50c",
  null
  
)

export default component.exports